import { Link } from 'react-router-dom';
import { Heart, Sparkle, HandHeart, Star, Users, ShieldCheck, ChatCircle } from '@phosphor-icons/react';
import { PageLayout } from '../components/Layout';
import { Button } from '../components/ui/button';

const Pillar = ({ icon: Icon, text }) => (
  <div className="flex items-start gap-3" data-testid="bio-pillar">
    <div className="mt-1 w-8 h-8 rounded-full bg-pink-100 flex items-center justify-center flex-shrink-0">
      <Icon weight="fill" className="w-4 h-4 text-primary" />
    </div>
    <span className="text-gray-700 leading-relaxed">{text}</span>
  </div>
);

const BioMission = () => {
  return (
    <PageLayout>
      <div className="min-h-screen bg-gradient-to-b from-pink-50/40 via-white to-amber-50/30">
        <div className="max-w-4xl mx-auto px-6 py-20">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-pink-100 text-primary text-xs tracking-widest uppercase mb-6" data-testid="biomission-eyebrow">
              <Heart weight="fill" className="w-3 h-3" />
              Who We Are
            </div>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-gray-900 mb-4" data-testid="biomission-title">
              Bio &amp; Mission
            </h1>
            <p className="script-font text-2xl text-primary">
              Real Love Starts with a Real Connection
            </p>
          </div>

          {/* BIO Section */}
          <section className="bg-white rounded-2xl shadow-sm border border-pink-100 p-8 md:p-12 mb-10" data-testid="bio-section">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <Sparkle weight="fill" className="w-6 h-6 text-primary" />
              </div>
              <h2 className="font-serif text-3xl text-gray-900">Bio</h2>
            </div>

            <p className="text-gray-700 text-base leading-relaxed mb-5">
              Link, Laugh &amp; Love is a social dating experience designed to bring singles together
              through laughter, good vibes, real conversation and ready to connect in a fun, respectful
              and uplifting environment. We create relaxed, no-pressure events where connections happen
              naturally. Singles come to mingle, laugh and see where the spark leads.
            </p>

            <p className="text-gray-700 text-base leading-relaxed mb-8">
              An online matchmaking service designed to connect intentional singles through personality,
              values and real-life compatibility — not endless swiping. We take the time to get to know you,
              so your connections feel natural, comfortable and genuine.
            </p>

            <div className="grid sm:grid-cols-2 gap-x-8 gap-y-4 pt-6 border-t border-pink-100">
              <Pillar icon={HandHeart} text="Personalized Matchmaking" />
              <Pillar icon={Users} text="One-on-one virtual introductions" />
              <Pillar icon={ChatCircle} text="Guided conversations &amp; date support" />
              <Pillar icon={ShieldCheck} text="Respectful, mature, no-pressure approach" />
              <Pillar icon={Star} text="Quality over quantity" />
              <Pillar icon={Heart} text="Real Love Starts with a Real Connection" />
            </div>
          </section>

          {/* MISSION Section */}
          <section className="bg-white rounded-2xl shadow-sm border border-pink-100 p-8 md:p-12 mb-12" data-testid="mission-section">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
                <Star weight="fill" className="w-6 h-6 text-amber-500" />
              </div>
              <h2 className="font-serif text-3xl text-gray-900">Mission</h2>
            </div>
            <p className="text-gray-700 text-base leading-relaxed">
              Our mission is to create safe, fun and inclusive spaces where singles can connect
              authentically through laughter, shared experiences and positive energy. We try to
              encourage meaningful relationships by creating social experiences that inspire connection,
              confidence and love.
            </p>
          </section>

          {/* CTA */}
          <div className="text-center">
            <Link to="/signup">
              <Button className="btn-primary" data-testid="biomission-cta">
                <Heart weight="fill" className="w-4 h-4 mr-2" />
                Start Your Journey
              </Button>
            </Link>
            <p className="text-sm text-muted-foreground mt-6">
              Questions?{' '}
              <a href="mailto:LinkLaughLoveMatch@gmail.com" className="text-primary hover:underline">
                LinkLaughLoveMatch@gmail.com
              </a>{' '}
              · <a href="tel:8107991060" className="text-primary hover:underline">(810) 799-1060</a>
            </p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default BioMission;
